import { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import './AboutUs.css'
import AboutUsForm from './AboutUsForm';
import { useCollections } from '../hooks/useCollection';

const AboutUs = () => {
  const { collections: aboutUsData, loading, error } = useCollections('aboutUs');
  const [currentData, setCurrentData] = useState(null);

  useEffect(() => {
    if (aboutUsData && aboutUsData.length > 0) {
      // If createdAt is a string, parse it or use the current data
      const processedData = aboutUsData.map(doc => ({
        ...doc,
        // Convert createdAt to a date if it's a string
        createdAt: typeof doc.createdAt === 'string' 
          ? new Date(doc.createdAt) 
          : doc.createdAt instanceof Date 
            ? doc.createdAt 
            : new Date()
      }));

      // Sort by createdAt in descending order
      const sortedData = processedData.sort((a, b) => 
        b.createdAt - a.createdAt
      );

      setCurrentData(sortedData[0]);
    }
  }, [aboutUsData]);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner-overlay">
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <p>Error loading About Us content: {error}</p>
      </div>
    );
  }

  return (
    <>
      <div className="aboutus-container">
        <div className="aboutus-content">
          <h2>{currentData?.title || 'About Us'}</h2>
          <div className="aboutus-grid">
            {currentData?.image1Url && (
              <img 
                src={currentData.image1Url} 
                alt="About Us" 
                className="aboutus-image" 
              />
            )}
            <div>
              <p>{currentData?.description1 || 'No description available'}</p>
            </div>
          </div>

          <div className="aboutus-grid aboutus-grid-2">
            <div>
              <p>{currentData?.description2 || 'No description available'}</p>
            </div>
            {currentData?.image2Url && (
              <img 
                src={currentData.image2Url} 
                alt="Team" 
                className="aboutus-image" 
              />
            )}
          </div>
        </div>
      </div>
      <AboutUsForm />
      <br />
      <Footer />
    </>
  );
};

export default AboutUs;